import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public propertyNumber : string;
  public bearerName : string;

  public showBearerDetails : boolean = true;
  public bearerEmail : string = "";
  public bearerMobile : string = "";

  constructor(private router : Router, private titleService : Title, private data: DataService) { 
    titleService.setTitle("DASHBOARD");
    this.data.showBackButton = false;
    console.log("dashboard loaded");
  }

  ngOnInit(): void {
    this.propertyNumber = this.data.SelectedCardNumber.substr(0,4) + " " + this.data.SelectedCardNumber.substr(4,4) + " " + this.data.SelectedCardNumber.substr(8,4) + " " + this.data.SelectedCardNumber.substr(12,4)
    this.bearerName = this.data.SelectedCardBearer.firstname + " " + this.data.SelectedCardBearer.lastname;
    this.bearerEmail = this.data.SelectedCardBearer.email;
    this.bearerMobile = this.data.SelectedCardBearer.mobile;
  }

  toggleBearerDetails(){
    this.showBearerDetails = !this.showBearerDetails;
  }

  onOwnershipSummary() :void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"
    this.router.navigate(["ownershipsummary"],{skipLocationChange: false});
  }

  onFinancialDetails() : void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"
    this.router.navigate(["financialdetails"],{skipLocationChange: false});
  }

  onPropertyDetails() :void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"
    this.router.navigate(["propertydetails"],{skipLocationChange: false});
  }

  

  onPropertyPhotos() :void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(["propertyphotos"],{skipLocationChange: false});
  }

  onPropertyDocuments() :void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(["propertydocuments"],{skipLocationChange: false});
  }

  onPinChange() : void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(["pinchange"],{skipLocationChange: false});
  }

  onUpdateDocuments() : void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(["documentupdate"],{skipLocationChange: false});
  }

  onLogoutClicked(): void{
    this.data.token = "";
    this.data.SelectedProperty = null;
    this.data.SelectedCardNumber = "";
    this.data.SelectedCardBearerID = "";
    this.data.isLoggedIn = false;
    this.data.SelectedCardBearer = null;
    this.data.MailReq = null;
    this.data.MailReqEx = null;
    this.data.backPath = "";
    this.data.showBackButton = false;
    this.data.PropertyTypes = null;
    this.data.PropertyOwnerTypes = null;
    this.data.ActiveDocumentViewRequest = null;

    localStorage.clear();

    this.data.RaiseEvent("logout");
  }

  onCustomerCare(): void {
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(['customercare'],{skipLocationChange:false});
  }

  onBlockCard(){
    this.data.showBackButton = true;
    this.data.backPath = "dashboard"

    this.router.navigate(['blockcard'],{skipLocationChange:false});
  }

}
